import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import InputField from "common/customInputField";
import SelectInput from "common/selectInput";
import Button from "react-bootstrap/Button";
import SearchTable from "./searchTable";
import { useNavigate, useParams } from "react-router-dom";
import { searchProjectsFilter, isValidEmail } from "utils/common";
import { searchMqProjectsSubmitForEdit, searchMqProjectNameEditSubmit } from "store/siteRepo/actionCreator";
import { searchIsLoggedInUser, updateMqSearchProjectFields } from "store/slices/siteRepo";
import searchIcon from "svg/search.svg";
import warning from "svg/warning.svg";
import NoAccessPage from "common/noAccessPage";
import { toast } from "react-toastify";

const SelectProject = () => {
  const navigate = useNavigate();
  const filterDropdownRef = useRef();
  const dispatch = useDispatch();
  const { siteId } = useParams();

  const { searchMqProjectsFields, showMqProjectSearchTable, isSearchOtherUser } = useSelector(
    (state) => state.siteRepo.editSite.searchMqProjects,
  );
  const { email, terrCcn, storeCcn } = useSelector((state) => state.loggedInUser);
  const { viewSite } = useSelector((state) => state.siteRepo);

  const handleMqProjectSearch = () => {
    if (searchMqProjectsFields.userEmail.length && !searchMqProjectsFields.projectSearch) {
      const isValidUserEmail = isValidEmail(searchMqProjectsFields.userEmail);
      if (!isValidUserEmail) {
        toast.error("Enter a valid email");
      } else {
        if (email?.toLowerCase() === searchMqProjectsFields.userEmail?.toLowerCase()) {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false, isEdit: true }));
        } else {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: true, isEdit: true }));
        }
        dispatch(searchMqProjectsSubmitForEdit({ searchMqProjectsFields, userId: searchMqProjectsFields.userEmail }));
      }
    } else if (searchMqProjectsFields.projectSearch.length && !searchMqProjectsFields.userEmail) {
      dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false, isEdit: true }));
      dispatch(
        searchMqProjectNameEditSubmit({
          searchMqProjectsFields,
          userId: email,
          name: searchMqProjectsFields.projectSearch,
        }),
      );
    } else if (searchMqProjectsFields.projectSearch.length && searchMqProjectsFields.userEmail.length) {
      const isValidUserEmail = isValidEmail(searchMqProjectsFields.userEmail);
      if (!isValidUserEmail) {
        toast.error("error", "Enter a valid email");
      } else {
        if (email?.toLowerCase() === searchMqProjectsFields.userEmail?.toLowerCase()) {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false, isEdit: true }));
        } else {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: true, isEdit: true }));
        }
        dispatch(
          searchMqProjectNameEditSubmit({
            searchMqProjectsFields,
            userId: searchMqProjectsFields.userEmail,
            name: searchMqProjectsFields.projectSearch,
          }),
        );
      }
    } else {
      dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false, isEdit: true }));
      dispatch(searchMqProjectsSubmitForEdit({ searchMqProjectsFields, userId: email }));
    }
  };

  const handleProjectTypeFilter = (e, value) => {
    const key = "projectType";
    dispatch(updateMqSearchProjectFields({ key, value, isEdit: true }));
  };
  const handleChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    dispatch(updateMqSearchProjectFields({ key, value, isEdit: true }));
  };

  return (viewSite.territory === terrCcn && viewSite.territory !== "800100") || storeCcn === viewSite.storeNumber ? (
    <div className="select-project-container d-flex flex-column justify-content-between">
      <div className="search-form-container px-0 border-0">
        <div className="search-form-container__fields">
          <form className="search-form-container__fields__form">
            <div className="row  mt-4 mt-md-0">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Project Name"
                  id="projectSearch"
                  placeholder="Enter a project name"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={searchMqProjectsFields.projectSearch}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                  image={searchIcon}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 search-form-container__fields__form-group">
                {" "}
                <SelectInput
                  options={searchProjectsFilter}
                  label="Filter"
                  defaultValue="Select a filter"
                  value={searchMqProjectsFields.projectType.description}
                  inputRef={filterDropdownRef}
                  handleSelectInput={(e, value) => handleProjectTypeFilter(e, value)}
                  disabled={false}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Email"
                  id="userEmail"
                  placeholder="Enter user email"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={searchMqProjectsFields.userEmail}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
            </div>
          </form>
          <div className="d-flex search-form-container__fields__btn">
            <div className="search-form-container__fields__btn__submit">
              <Button varant="primary" onClick={handleMqProjectSearch}>
                Search
              </Button>
            </div>
          </div>
        </div>
      </div>
      {showMqProjectSearchTable && isSearchOtherUser && (
        <div className="alert d-flex align-items-center" role="alert">
          <img src={warning} alt={"warning-icon"} />
          <div>
            You are searching projects for
            <b>{" " + searchMqProjectsFields.userEmail}</b>.
          </div>
        </div>
      )}
      {showMqProjectSearchTable && <SearchTable />}
      <div className="d-flex justify-content-between flex-column-reverse flex-md-row">
        <Button variant="outline-primary" onClick={() => navigate(`/siteRepo/site/${siteId}`)}>
          Cancel
        </Button>
        <Button
          className="m-0"
          variant="primary"
          onClick={() => navigate(`/siteRepo/editSite/${siteId}#site-details-editable`)}
        >
          Next
        </Button>
      </div>
    </div>
  ) : (
    <NoAccessPage />
  );
};

export default SelectProject;
